/* Jacket Aura Store Theme 2.6.6.1 — one lifecycle for native sections, Ajax replacements and the editor. */
(() => {
  'use strict';
  const boot = document.currentScript;
  const roots = new Map(), controllers = new Map(), hooks = new Set(), adoptedStyles = new Set();
  const modules = [
    {name:'editorial', selector:'[data-product-shell],[data-reveal],[data-slideshow],[data-comparison-range],[data-marquee-pause],[data-quote-carousel],.hotspot,[data-tabs],[data-reveal-scene],[data-count-up],[data-newsletter-popup],[data-recommendations],[data-selector-style],[data-feature-chart],[data-header],[data-gallery-track],[data-auto-video],.recipient-fields,[data-look]',url:boot?.dataset.editorial},
    {name:'merchandising',selector:'[data-card-swatch],[data-swatch-color],[data-announcement],[data-row-limit],[data-timeline],[data-native-share],[data-print],[data-gift-qr],[data-complementary],[data-recent-section],[data-play-section],[data-block-video-toggle]',url:boot?.dataset.merchandising},
    {name:'experience',selector:'[data-link-blocks],[data-multiple-images],[data-scrolling-story],[data-country-flag-enabled=true],[data-shipping-estimator],[data-show-progress],.horizontal-cards,[data-video-toggle],[data-product-zoom]',url:boot?.dataset.experience},
    {name:'platform',selector:'[data-predictive-search],[data-consent-banner],model-viewer,[data-external-video]',url:boot?.dataset.platform},
    {name:'jacket-aura-ui',selector:'[data-ja-announcement],[data-ja-scroll-rail],[data-ja-marquee],[data-ja-description-toggle],[data-ja-filter-toggle],[data-ja-process-media-step],[data-ja-mobile-pagination]',url:boot?.dataset.ui}
  ];
  const matches = (root,selector) => root.matches?.(selector) || root.querySelector(selector);
  function dispose(root) {
    const active = roots.get(root);
    if (!active) return;
    for (const [name] of active) controllers.get(name)?.unmount(root);
    roots.delete(root);
  }
  function apply(root) {
    if (!root.isConnected) return;
    if (!roots.has(root)) roots.set(root,new Map());
    const active=roots.get(root);
    for (const [name,controller] of controllers) {
      if (active.has(name) || !matches(root,controller.selector)) continue;
      controller.mount(root);active.set(name,true);
    }
    for (const module of modules) {
      if (module.loading || !module.url || !matches(root,module.selector)) continue;
      module.loading=true;
      const script=document.createElement('script');script.src=module.url;script.async=true;
      script.dataset.atelierModule=module.name;
      script.addEventListener('error',()=>{module.loading=false;script.remove()},{once:true});
      document.head.append(script);
    }
  }
  function sections(root=document) {
    const found=[...(root.matches?.('.shopify-section')?[root]:[]),...root.querySelectorAll('.shopify-section')];
    return found.length?found:[root];
  }
  function update(root=document) {
    for(const section of sections(root)){dispose(section);apply(section)}
    for(const hook of hooks)hook();
    if(matches(root,'.shopify-payment-button'))window.Shopify?.PaymentButton?.init?.();
  }
  window.Atelier={
    register(name,controller){if(controllers.has(name))return;controllers.set(name,controller);for(const root of roots.keys())apply(root)},
    afterUpdate(callback){hooks.add(callback);callback()},
    update,
    adoptStyles(parsed){for(const style of parsed.querySelectorAll('style[data-section-stylesheet]')){const css=style.textContent;if(adoptedStyles.has(css))continue;adoptedStyles.add(css);document.head.append(style.cloneNode(true));}},
    unmount(root){for(const section of sections(root))dispose(section);dispose(root)}
  };
  // Shopify renders sections independently. Aggregate their FAQ entries into one
  // page-level JSON-LD node; rerun on editor/AJAX updates to prevent duplicates.
  function updateFaqSchema() {
    const entries = [], seen = new Set();
    document.querySelectorAll('script[type="application/json"][data-ja-faq-items]').forEach(source => {
      try {
        const questions = JSON.parse(source.textContent);
        if (!Array.isArray(questions)) return;
        questions.forEach(item => {
          if (item?.['@type'] !== 'Question' || typeof item.name !== 'string' ||
              item.acceptedAnswer?.['@type'] !== 'Answer' ||
              typeof item.acceptedAnswer.text !== 'string') return;
          const key = `${item.name}\u0000${item.acceptedAnswer.text}`;
          if (!item.name.trim() || !item.acceptedAnswer.text.trim() || seen.has(key)) return;
          seen.add(key);
          entries.push(item);
        });
      } catch { /* Do not break storefront interactions for invalid optional schema. */ }
    });
    let node = document.getElementById('jacket-aura-faq-schema');
    if (!entries.length) { node?.remove(); return; }
    if (!node) {
      node = document.createElement('script');
      node.id = 'jacket-aura-faq-schema';
      node.type = 'application/ld+json';
      document.head.append(node);
    }
    node.textContent = JSON.stringify({'@context':'https://schema.org','@type':'FAQPage',mainEntity:entries});
  }
  window.Atelier.afterUpdate(updateFaqSchema);
  document.addEventListener('shopify:section:load',event=>update(event.target));
  document.addEventListener('shopify:section:unload',event=>{window.Atelier.unmount(event.target);queueMicrotask(updateFaqSchema);});
  document.addEventListener('atelier:section-unmount',event=>window.Atelier.unmount(event.target));
  for(const name of ['atelier:product-updated','atelier:cart-updated','atelier:content-updated'])
    document.addEventListener(name,event=>update(event.detail.section.closest?.('[data-quick-dialog]')||event.detail.section.closest?.('.shopify-section')||event.detail.section));
  // Native dialogs trap focus, dismiss on Escape and restore their opener.
  document.addEventListener('click',event=>{
    const dialog=event.target;
    if(dialog?.tagName!=='DIALOG'||!dialog.open)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  });
  // Eased same-page anchors only. Native wheel/trackpad/touch scrolling is never
  // hijacked, and skip links / reduced-motion / Theme Editor keep native behavior.
  (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let cleanup = null;
    const cancel = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      cleanup?.();
      cleanup = null;
      document.documentElement.classList.remove('ja-eased-scroll');
    };
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey ||
          event.shiftKey || event.altKey || reduced.matches || window.Shopify?.designMode) return;
      const link = event.target.closest?.('a[href*="#"]');
      if (!link || link.classList.contains('skip-link') || link.hasAttribute('download') ||
          (link.target && link.target !== '_self')) return;
      let url;
      try { url = new URL(link.href, location.href); } catch { return; }
      if (url.origin !== location.origin || url.pathname !== location.pathname ||
          url.search !== location.search || !url.hash || url.hash === '#') return;
      let id;
      try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target || target.closest('dialog,[data-gallery-track],.tab-buttons')) return;
      const headerOffset = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      const finish = Math.max(0, Math.min(document.documentElement.scrollHeight - innerHeight,
        target.getBoundingClientRect().top + scrollY - headerOffset));
      const start = scrollY;
      if (Math.abs(finish - start) < 3) return;
      event.preventDefault();
      cancel();
      document.documentElement.classList.add('ja-eased-scroll');
      const duration = Math.min(950, Math.max(440, Math.abs(finish - start) * .42));
      const initiated = performance.now();
      const stop = () => cancel();
      for (const kind of ['wheel','touchstart','pointerdown','keydown'])
        window.addEventListener(kind, stop, {capture:true, passive:true});
      cleanup = () => {
        for (const kind of ['wheel','touchstart','pointerdown','keydown'])
          window.removeEventListener(kind, stop, true);
      };
      const draw = now => {
        const fraction = Math.min(1, (now - initiated) / duration);
        const ease = 1 - Math.pow(1 - fraction, 4);
        window.scrollTo(0, start + (finish - start) * ease);
        if (fraction < 1 && !reduced.matches) frame = requestAnimationFrame(draw);
        else {
          cancel();
          if (location.hash !== url.hash) history.pushState(null, '', url.hash);
          // Move keyboard focus to the anchor destination without causing another jump.
          const wasFocusable = target.hasAttribute('tabindex') ||
            /^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName);
          if (!wasFocusable) {
            target.setAttribute('tabindex', '-1');
            target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once:true});
          }
          target.focus({preventScroll:true});
        }
      };
      frame = requestAnimationFrame(draw);
    });
  })();
  queueMicrotask(()=>update());
})();
/* Original Jacket Aura Store Theme interactions. No theme/framework dependencies. */
(() => {
  'use strict';
  const configuration = document.getElementById('atelier-config');
  if (!configuration) return;
  let config;
  try { config = JSON.parse(configuration.textContent); } catch { return; }
  const route = suffix => `${config.root.replace(/\/?$/, '/')}${suffix}`;
  function scopeProductIds(root, prefix) {
    const ids = new Map();
    root.querySelectorAll('[id]').forEach(element => {const before=element.id;const after=prefix+before;ids.set(before,after);element.id=after;});
    root.querySelectorAll('[for],[form],[aria-controls],[aria-labelledby],[aria-describedby],[data-gallery-target]').forEach(element => {
      for (const name of ['for','form','aria-controls','aria-labelledby','aria-describedby','data-gallery-target']) {
        if (!element.hasAttribute(name)) continue;
        element.setAttribute(name,element.getAttribute(name).split(/\s+/).map(id=>ids.get(id)||id).join(' '));
      }
    });
    const shell=root.matches?.('[data-product-shell]')?root:root.querySelector('[data-product-shell]');
    if(shell)shell.dataset.scopePrefix=prefix;
  }
  document.addEventListener('atelier:scope-product',event=>scopeProductIds(event.detail.root,event.detail.prefix));
  let queue = Promise.resolve();
  const inFlightForms = new WeakSet();
  const variantRequests = new WeakMap();
  let cartOpener;let cartPending=0;
  function enqueue(task) {
    const operation = queue.then(task, task);
    queue = operation.catch(() => {});
    return operation;
  }
  async function request(url, options = {}, format = 'json') {
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (options.signal?.aborted) abort();
    options.signal?.addEventListener('abort', abort, { once: true });
    const timer = setTimeout(abort, 15000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin' });
      const text = await response.text();
      if (!response.ok) {
        const error = new Error(`Request failed (${response.status})`);
        error.status = response.status;
        try { error.description = JSON.parse(text).description; } catch { /* Keep generic status. */ }
        throw error;
      }
      return format === 'text' ? text : JSON.parse(text);
    } finally {
      clearTimeout(timer);
      options.signal?.removeEventListener('abort', abort);
    }
  }
  function announce(message) {
    const target = document.querySelector('[data-announcer]');
    if (target) target.textContent = message;
  }
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = String(count); });
  }
  function openCart(opener) {
    const panel = document.getElementById('CartPanel');
    if (!panel?.showModal) return false;
    cartOpener = opener || document.activeElement;
    if (!panel.open) panel.showModal();
    return true;
  }
  async function refreshCart() {
    const url = new URL(config.cart, location.origin);
    url.searchParams.set('section_id', document.getElementById('CartPanel')?.dataset.cartSection || 'cart-panel');
    const html = await request(url, {}, 'text');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-cart-content]');
    const current = document.querySelector('#CartPanel [data-cart-content]');
    if (!next || !current) throw new Error('Cart section was not returned');
    // Preserve unsaved shopper-entered note/discount through drawer quantity and cart refreshes.
    const draftFields = ['note', 'discount'].map(name => ({ name, field: current.querySelector(`[name="${name}"]`) })).filter(entry => entry.field);
    const drafts = draftFields.map(({ name, field }) => ({ name, value: field.value }));
    if(document.getElementById('CartPanel')?.getAttribute('aria-busy')==='true')next.inert=true;
    window.Atelier.adoptStyles(parsed);current.replaceWith(next);
    drafts.forEach(({name,value}) => {const field=next.querySelector(`[name="${name}"]`); if(field)field.value=value;});
    setCount(Number(next.dataset.count) || 0);document.dispatchEvent(new CustomEvent('atelier:cart-updated',{detail:{section:next.closest('.shopify-section')||next}}));
  }
  let addedOpener;
  function showAdded(response,submitter,shell) {
    const panel=document.getElementById('AddedPanel');
    if(!panel)return false;
    const content=panel.querySelector('[data-added-content]');
    const rendered=response?.sections?.['variant-added'];
    if(typeof rendered==='string') {
      const parsed=new DOMParser().parseFromString(rendered,'text/html');
      const receipt=parsed.querySelector('[data-variant-added]');
      if(receipt){window.Atelier.adoptStyles(parsed);content.replaceChildren(receipt)}
      else content.replaceChildren(panel.querySelector('template').content.cloneNode(true));
    } else content.replaceChildren(panel.querySelector('template').content.cloneNode(true));
    const item=response?.items?.[0]||response||{};
    if(content.querySelector('[data-added-title]')) {
      const title=content.querySelector('[data-added-title]');title.textContent=item.product_title||item.title||shell?.querySelector('h1,h2')?.textContent||config.added;
      const url=item.url||shell?.dataset.productUrl||config.cart;
      try{const target=new URL(url,location.origin);title.href=target.origin===location.origin?target.href:config.cart}catch{title.href=config.cart}
      const variant=content.querySelector('[data-added-variant]');variant.textContent=item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'';
      const image=content.querySelector('[data-added-image]');const source=item.featured_image?.url||item.image;
      if(typeof source==='string'){try{const url=new URL(source,location.origin);if(['http:','https:'].includes(url.protocol)){image.src=url.href;image.alt=title.textContent;image.hidden=false}}catch{}}
      const price=content.querySelector('[data-added-price]');const amount=item.final_line_price??item.final_price??item.price;
      if(Number.isFinite(Number(amount))&&amount!=null){try{price.textContent=new Intl.NumberFormat(config.locale||document.documentElement.lang,{style:'currency',currency:config.currency||window.Shopify?.currency?.active||'USD'}).format(Number(amount)/100)}catch{price.textContent=''}}
    }
    const quick=shell?.closest('[data-quick-dialog]');
    if(quick){
      quick.dispatchEvent(new CustomEvent('atelier:section-unmount',{bubbles:true}));
      const close=quick.querySelector('button');quick.replaceChildren(close,content.cloneNode(true));return true;
    }
    addedOpener=submitter||document.activeElement;
    if(!panel.open)panel.showModal();return true;
  }
  document.addEventListener('close',event=>{if(event.target.id==='AddedPanel'&&addedOpener?.isConnected)addedOpener.focus({preventScroll:true})},true);
  const combineDiscounts=(content,newValue='')=>{
    const values=[...(content?.dataset.appliedDiscounts||'').split(','),...newValue.split(',')].map(v=>v.trim()).filter(Boolean);
    const seen=new Set();return values.filter(v=>{const key=v.toUpperCase();if(seen.has(key))return false;seen.add(key);return true}).join(',');
  };
  async function addProduct(form, submitter) {
    if (inFlightForms.has(form) || form.closest('[data-product-shell]')?.getAttribute('aria-busy') === 'true') return;
    if (!form.reportValidity()) return;
    inFlightForms.add(form);
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    const disabledStates = buttons.map(button => button.disabled);
    const shell = form.closest('[data-product-shell]');
    const status = shell?.querySelector('[data-purchase-feedback]');
    const recovery = shell?.querySelector('[data-purchase-recovery]');
    if (status) status.textContent = '';
    if (recovery) recovery.hidden = true;
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const body = new FormData(form);
    const variantId=String(body.get('id')||'');
    if(/^\d+$/.test(variantId)){body.set('sections','variant-added');body.set('sections_url',route('variants/'+variantId));}
    try {
      await enqueue(async () => {
        const addition=await request(route('cart/add.js'), { method: 'POST', body, headers: { Accept: 'application/json','X-Requested-With':'XMLHttpRequest' } });
        if (status) status.textContent = config.added;
        announce(config.added);
        if (recovery) recovery.hidden = false;
        // A failed refresh must never retry a mutation that may already have succeeded.
        let refreshed=false;
        try {await refreshCart();refreshed=true;} catch {
          if (status) status.textContent = `${config.added} ${config.addError}`;
        }
        if(document.body.dataset.cartType==='popover'||shell?.closest('[data-quick-dialog]')) {
          if(!showAdded(addition,submitter,shell)&&refreshed)openCart(submitter);
        } else if(refreshed&&document.body.dataset.cartDrawer==='true')openCart(submitter);
        else if(refreshed && form.matches('[data-card-add-form]')) location.assign(config.cart);
      });
    } catch (error) {
      const message = error.status === 422 && typeof error.description === 'string' ? error.description : config.addError;
      if (status) status.textContent = message;
      if (recovery) recovery.hidden = false;
      announce(message);
    } finally {
      inFlightForms.delete(form);
      buttons.forEach((button, index) => { button.disabled = disabledStates[index]; button.removeAttribute('aria-busy'); });
    }
  }
  const cartTimers=new WeakMap();
  async function editCart(payload,source){
    const panel=document.getElementById('CartPanel');if(!panel)return;
    if(source?.disabled)return;
    cartPending++;panel.setAttribute('aria-busy','true');const content=panel.querySelector('[data-cart-content]');if(content)content.inert=true;
    if(source?.tagName==='BUTTON')source.disabled=true;
    try{await enqueue(async()=>{
      await request(route(payload.id?'cart/change.js':'cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      await refreshCart();
    });}
    catch(error){try{await enqueue(refreshCart)}catch{/* Preserve the native recovery link. */}let status=panel.querySelector('[data-cart-error]');if(!status){status=document.createElement('p');status.dataset.cartError='';status.role='alert';panel.append(status)}status.textContent=typeof error.description==='string'?error.description:config.addError;const link=document.createElement('a');link.href=config.cart;link.textContent=document.querySelector('[data-purchase-recovery]')?.textContent||document.querySelector('[data-open-cart]')?.getAttribute('aria-label')||config.reload;link.className='text-link';status.append(document.createTextNode(' '),link);}
    finally{cartPending--;if(!cartPending){panel.removeAttribute('aria-busy');const active=panel.querySelector('[data-cart-content]');if(active)active.inert=false;const quantity=source?.tagName==='INPUT'?source.dataset.lineKey:null;const input=quantity?[...panel.querySelectorAll('[data-line-key]')].find(n=>n.tagName==='INPUT'&&n.dataset.lineKey===quantity):null;input?.focus({preventScroll:true})}if(source?.tagName==='BUTTON')source.disabled=false;}
  }
  document.addEventListener('click',event=>{const adjust=event.target.closest('[data-quantity-adjust]');if(!adjust||adjust.disabled)return;const group=adjust.closest('[data-quantity-selector]');const input=group?.querySelector('input[type="number"]');if(!input||input.disabled)return;event.preventDefault();const before=Number(input.value)||Number(input.min)||0;try{adjust.dataset.quantityAdjust==='increase'?input.stepUp():input.stepDown()}catch{const step=Number(input.step)||1;input.value=String(before+(adjust.dataset.quantityAdjust==='increase'?step:-step))}if(!input.reportValidity()){input.value=String(before);return}input.dispatchEvent(new Event('input',{bubbles:true}));if(input.closest('#CartPanel'))input.dispatchEvent(new Event('change',{bubbles:true}));});
  document.addEventListener('change',event=>{const input=event.target.closest('#CartPanel [data-line-key][name="updates[]"]');if(!input||!input.reportValidity())return;clearTimeout(cartTimers.get(input));cartTimers.set(input,setTimeout(()=>{cartTimers.delete(input);void editCart({id:input.dataset.lineKey,quantity:Number(input.value)},input)},300));});
  document.addEventListener('submit',event=>{const form=event.target;if(!form.matches('#CartPanel .cart-form'))return;form.querySelectorAll('[data-line-key][name="updates[]"]').forEach(input=>{clearTimeout(cartTimers.get(input));cartTimers.delete(input)});if(document.getElementById('CartPanel')?.getAttribute('aria-busy')==='true'){event.preventDefault();return}if(event.submitter?.name==='checkout'){const discount=form.elements.namedItem('discount');if(discount)discount.value=combineDiscounts(form.closest('[data-cart-content]'),discount.value);return;}event.preventDefault();if(!form.reportValidity())return;const updates={};form.querySelectorAll('[data-line-key][name="updates[]"]').forEach(input=>{clearTimeout(cartTimers.get(input));updates[input.dataset.lineKey]=Number(input.value)});const payload={updates};for(const name of ['note','discount']){const field=form.elements.namedItem(name);if(field)payload[name]=name==='discount'?combineDiscounts(form.closest('[data-cart-content]'),field.value):field.value}void editCart(payload,event.submitter);});
  document.addEventListener('click',event=>{const remove=event.target.closest('#CartPanel [data-line-remove]');if(!remove||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();void editCart({id:remove.dataset.lineKey,quantity:0},remove);});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-discount-remove]');if(!button||button.disabled)return;
    const content=button.closest('[data-cart-content]');
    const codes=(content?.dataset.appliedDiscounts||'').split(',').map(v=>v.trim()).filter(v=>v&&v.toUpperCase()!==button.dataset.discountRemove.toUpperCase());
    if(button.closest('#CartPanel'))void editCart({discount:codes.join(',')},button);
    else{button.disabled=true;void enqueue(()=>request(route('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})})).then(()=>location.reload()).catch(()=>{button.disabled=false;announce(config.addError)})}
  });
  async function selectOption(link, preferSelect = false) {
    const shell = link.closest('[data-product-shell]');
    if (!shell) return;
    const sibling = link.dataset.siblingUrl;
    if (sibling && new URL(sibling, location.origin).pathname !== new URL(shell.dataset.productUrl, location.origin).pathname) {
      location.assign(link.href);
      return;
    }
    const previous = variantRequests.get(shell);
    previous?.abort();
    const controller = new AbortController();
    variantRequests.set(shell, controller);
    const field = link.closest('[data-option-position]');
    field.dataset.optionCurrent = link.dataset.optionValue;
    const chosen = [...shell.querySelectorAll('[data-option-position]')].map(element => element.dataset.optionCurrent);
    const pageUrl = new URL(shell.dataset.productUrl, location.origin);
    pageUrl.searchParams.set('option_values', chosen.join(','));
    const requestUrl = new URL(pageUrl);
    requestUrl.searchParams.set('section_id', shell.dataset.sectionId);
    shell.setAttribute('aria-busy', 'true');
    // All purchase mechanisms, including accelerated checkout, are inert until the selected variant resolves.
    const form = shell.querySelector('[data-purchase-form]');
    if (form) form.inert = true;
    shell.querySelectorAll('[data-add-button], [data-fixed-add]').forEach(button => { button.disabled = true; });
    const feedback = shell.querySelector('[data-purchase-feedback]');
    if (feedback) feedback.textContent = '';
    try {
      const html = await request(requestUrl, { signal: controller.signal }, 'text');
      if (variantRequests.get(shell) !== controller || !shell.isConnected) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-product-shell]');
      if (!next) throw new Error('Product section was not returned');
      if (shell.dataset.scopePrefix) scopeProductIds(next,shell.dataset.scopePrefix);
      // Preserve quantity only if valid for the newly selected variant.
      const quantity = shell.querySelector('[name="quantity"]')?.value;
      const nextQuantity = next.querySelector('[name="quantity"]');
      if (nextQuantity && quantity) {
        const defaultQuantity = nextQuantity.value;
        nextQuantity.value = quantity;
        if (!nextQuantity.checkValidity()) nextQuantity.value = defaultQuantity;
      }
      // Preserve customer-entered recipient properties and a still-valid purchase plan.
      const nextForm = next.querySelector('[data-purchase-form]');
      if (form && nextForm) [...form.elements].forEach(input => {
        if (!input.name?.startsWith('properties[') && input.name !== 'selling_plan') return;
        const replacement = [...nextForm.elements].find(element => element.name === input.name);
        if (!replacement) return;
        if (input.type === 'checkbox') replacement.checked = input.checked;
        else if (input.name !== 'selling_plan' || [...replacement.options].some(option => option.value === input.value)) replacement.value = input.value;
      });
      const focusedId = link.dataset.optionValue;
      const focusedPosition = field.dataset.optionPosition;
      window.Atelier.adoptStyles(parsed);shell.replaceWith(next);
      if (next.dataset.featured !== 'true' && !next.closest('[data-quick-dialog]')) history.replaceState({}, '', pageUrl);
      document.dispatchEvent(new CustomEvent('atelier:product-updated', { detail: { section: next } }));
      const focusTarget = preferSelect ? next.querySelector(`[data-option-position="${CSS.escape(focusedPosition)}"] [data-variant-select]`) : next.querySelector(`[data-option-value="${CSS.escape(focusedId)}"]`);
      focusTarget?.focus({ preventScroll: true });
    } catch (error) {
      if (variantRequests.get(shell) !== controller || !shell.isConnected) return;
      // A failed selection must not permit adding the previously displayed variant.
      if (feedback) {
        feedback.textContent = `${config.variantError} `;
        const recovery = document.createElement('a');
        recovery.href = pageUrl.href;
        recovery.textContent = config.reload;
        feedback.append(recovery);
      }
      announce(config.variantError);
    } finally {
      if (variantRequests.get(shell) === controller) variantRequests.delete(shell);
    }
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const link = select.closest('[data-option-position]').querySelector(`[data-option-value="${CSS.escape(select.value)}"]`);
    if (link) void selectOption(link, true);
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-card-add-form]')) { event.preventDefault(); void addProduct(event.target, event.submitter); return; }
    if (!event.target.matches('[data-purchase-form]') || document.body.dataset.cartDrawer !== 'true') return;
    event.preventDefault();
    void addProduct(event.target, event.submitter);
  });
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-option-value]');
    if (option && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      void selectOption(option);
      return;
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    const cart = event.target.closest('[data-open-cart]');
    if (cart && document.body.dataset.cartDrawer === 'true' && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      const panel = document.getElementById('CartPanel');
      if (!panel?.showModal) return;
      event.preventDefault();
      // Queue read after local pending mutations; navigate to the native cart if rendering fails.
      void enqueue(refreshCart).then(() => { if (!openCart(cart)) location.assign(config.cart); }).catch(() => location.assign(config.cart));
    }
  });
  document.addEventListener('close', event => {
    if (event.target.id === 'CartPanel' && cartOpener?.isConnected) cartOpener.focus({ preventScroll: true });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open], .mobile-menu[open], .filter[open]').forEach(details => {
      details.open = false;
      if (details.contains(document.activeElement)) details.querySelector('summary')?.focus();
    });
  });
  function setupAddressForms(root = document) {
    root.querySelectorAll('[data-address-country]').forEach(country => {
      if (country.dataset.ready) return;
      country.dataset.ready = 'true';
      const province = document.getElementById(country.dataset.provinceId);
      if (!province) return;
      if (country.dataset.default) country.value = country.dataset.default;
      const fill = initial => {
        let provinces = [];
        try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { /* Use no provinces. */ }
        province.replaceChildren();
        provinces.forEach(([value, label]) => province.add(new Option(label, value)));
        province.closest('[data-province-field]').hidden = provinces.length === 0;
        province.disabled = provinces.length === 0;
        if (initial && province.dataset.default) province.value = province.dataset.default;
      };
      country.addEventListener('change', () => fill(false));
      fill(true);
    });
  }
  setupAddressForms();
  document.addEventListener('shopify:section:load', event => setupAddressForms(event.target));
})();

(() => {
  let headerAbort;

  function header() {
    headerAbort?.abort();
    headerAbort = new AbortController();
    const { signal } = headerAbort;
    const node = document.querySelector('[data-header]');

    if (!node) {
      document.documentElement.classList.remove('has-transparent-header');
      document.documentElement.style.removeProperty('--header-height');
      return;
    }

    const first = document.querySelector('#MainContent > .shopify-section') || document.querySelector('#MainContent')?.firstElementChild;
    const transparentTarget = first?.matches('[data-transparent-header="true"]') || first?.querySelector('[data-transparent-header="true"]');
    const hoverQuery = matchMedia('(min-width: 1150px) and (hover: hover) and (pointer: fine)');
    const details = [...node.querySelectorAll('.nav-dropdown')];
    let lastY = Math.max(0, scrollY);
    let raf = 0;
    let closeTimer = 0;

    const closeOthers = current => {
      details.forEach(detail => {
        if (detail !== current) detail.open = false;
      });
    };

    if (node.dataset.menuTrigger === 'hover') {
      details.forEach(detail => {
        detail.addEventListener('pointerenter', () => {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          closeOthers(detail);
          detail.open = true;
          schedule();
        }, { signal });
        detail.addEventListener('pointerleave', () => {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => {
            if (!detail.matches(':hover') && !detail.contains(document.activeElement)) detail.open = false;
            schedule();
          }, 140);
        }, { signal });
      });
    }

    const update = () => {
      raf = 0;
      const y = Math.max(0, scrollY);
      const delta = y - lastY;
      const menuOpen = details.some(detail => detail.open) || Boolean(node.querySelector('.mobile-menu[open]'));
      const focused = node.contains(document.activeElement);
      const threshold = Math.max(8, node.offsetHeight * .16);
      const filled = !transparentTarget || y > threshold || menuOpen;
      const transparent = Boolean(transparentTarget) && !filled;

      document.documentElement.style.setProperty('--header-height', `${Math.round(node.getBoundingClientRect().height)}px`);
      document.documentElement.classList.toggle('has-transparent-header', Boolean(transparentTarget));
      node.classList.toggle('is-transparent', transparent);
      node.classList.toggle('is-filled', filled);

      let hide = false;
      if (node.dataset.hideOnScroll === 'true' && node.dataset.sticky === 'true' && !menuOpen && !focused && y > node.offsetHeight * 2) {
        hide = delta > 4;
        if (delta < -4) hide = false;
        else if (node.classList.contains('is-hidden') && delta >= -4) hide = true;
      }
      node.classList.toggle('is-hidden', hide);
      lastY = y;
    };

    const schedule = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    node.addEventListener('toggle', schedule, { capture: true, signal });
    node.addEventListener('focusin', schedule, { signal });
    node.addEventListener('focusout', schedule, { signal });
    hoverQuery.addEventListener('change', () => {
      if (!hoverQuery.matches) details.forEach(detail => { detail.open = false; });
      schedule();
    }, { signal });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(node);
      signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }

    signal.addEventListener('abort', () => {
      cancelAnimationFrame(raf);
      clearTimeout(closeTimer);
    }, { once: true });

    update();
  }

  window.Atelier.afterUpdate(header);
})();

// Jacket Aura related-product carousel navigation (works after section re-renders).
document.addEventListener('click',event=>{
 const control=event.target.closest('[data-related-step]'); if(!control)return;
 const section=control.closest('.migration-band');const rail=section?.querySelector('[data-related-carousel]');
 if(!rail)return;const first=rail.querySelector('.product-card');const gap=parseFloat(getComputedStyle(rail).columnGap)||24;
 const step=(first?.getBoundingClientRect().width||260)+gap;
 rail.scrollBy({left:step*Number(control.dataset.relatedStep),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});

